import * as React from 'react'

type ErrorProps = {
  message?: string
}

export const Error: React.FC<ErrorProps> = ({ message }) => {
  return <div className="mt-2 text-destructive text-sm">{message ?? 'This field is required'}</div>
}
